import React from 'react';

const ReviewsRatingsComponent = () => {
    return (
        <>
           <h2 className=' text-xl font-bold border-t-2 border-slate-200'>
            Ratings & Reviews 
           </h2>
            <p>
            <i class="fa-solid fa-star text-2xl"></i>
            <i class="fa-solid fa-star text-2xl"></i>
            <i class="fa-solid fa-star text-2xl"></i>
            <i class="fa-solid fa-star text-2xl"></i>
            <i class="fa-regular fa-star text-2xl"></i>
            </p>
            <div>
            <h2 className=' text-xl font-bold'>
            Comments
            </h2>
            <div className='flex flex-col gap-3 p-2 justify-center items-center border-2 border-slate-200 rounded-md h-[12rem] overflow-scroll'>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas, laudantium!</p>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas, laudantium!</p>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas, laudantium!</p>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas, laudantium!</p>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas, laudantium!</p>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas, laudantium!</p>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas, laudantium!</p>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas, laudantium!</p>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas, laudantium!</p>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas, laudantium!</p>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas, laudantium!</p>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas, laudantium!</p>
            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quas, laudantium!</p>
            </div>
            </div> 
        </>
    );
}

export default ReviewsRatingsComponent;
